import React, { useCallback } from "react"
import { Button } from "react-bootstrap"

import { isNumber } from "../../../utils"
import { useTagListState } from "../../../graphing/resources/TagOptionsWidget"

export default function MetricsTable({
  metrics,
  values,
  plotList,
  fontPercent,
  updateMetrics,
  getColWidth,
  colValueStyle,
}) {
  const removeTrend = useCallback(
    (e, tagNum) => {
      e.preventDefault()
      const modMetrics = [...metrics]
      modMetrics.splice(tagNum, 1)
      updateMetrics(modMetrics, false)
    },
    [metrics],
  )

  const [_, tagInfoLookup] = useTagListState(plotList)

  return (
    <>
      {metrics
        .map((t) => t.tag)
        .filter((value) => Object.keys(values).includes(value))
        .map((tag, tagNum) => {
          const tag_info = values[tag] || {}
          const label = (tagInfoLookup.find((t) => t.tag === tag) || {}).label
          const tagDesc = !label || label === tag ? tag : `${label}__[${tag}]`
          const contents = [
            <>
              {tagDesc.split("__").map((row, descIDX) => (
                <div key={`${tagNum}_${descIDX}`}>{row}</div>
              ))}
            </>,
            <>{`${isNumber(tag_info.value) ? tag_info.value.toFixed(2) : "-"}`}</>,
            <>{tag_info.units || "-"}</>,
            <Button
              style={{ marginLeft: "auto", padding: "0 4px" }}
              variant={"outline-primary"}
              className={"btn btn-sm"}
              disabled={metrics.length <= 1}
              onClick={(e) => removeTrend(e, tagNum)}
            >
              <span className="fa fa-minus-circle" />
            </Button>,
          ]
          return (
            <div
              key={`content_row_${tagNum}`}
              className={"row div-row"}
              style={{ borderBottom: "1px solid var(--lanzalake-blue-bright)", margin: "0" }}
            >
              {contents.map((content, colIDX) => (
                <div
                  key={`content_row_${tagNum}_${colIDX}`}
                  className={`col-${getColWidth(colIDX)} text-center`}
                  style={{ padding: "0" }}
                >
                  <div
                    style={{
                      fontSize: `${fontPercent}%`,
                      ...colValueStyle,
                    }}
                  >
                    {content}
                  </div>
                </div>
              ))}
            </div>
          )
        })}
    </>
  )
}
